module.exports = __webpack_public_path__ + "static/media/Abomasnow_gaussian2.59f7cc5d.png";